import { Outlet, Navigate } from 'react-router-dom'
import { getAuthToken,getDecodedToken, clearSession } from './auth';

const PrivateRoutes = () => {
  const token = getAuthToken();

  if (!token) return <Navigate to="/login" />;

  const decoded = getDecodedToken(token);

  if (!decoded?.exp || Date.now() / 1000 >= decoded.exp) {
    clearSession();
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};


export default PrivateRoutes